import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-activity-common-footer',
    templateUrl: './activity-common-footer.component.html',
    styleUrls: ['./activity-common-footer.component.scss'],
    standalone: false
})
export class ActivityCommonFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    return;
  }

}

